import { BlobServiceClient } from "@azure/storage-blob";

const accountName = process.env.REACT_APP_AZURE_STORAGE_ACCOUNT;
const containerName = process.env.REACT_APP_AZURE_CONTAINER_NAME;
// const sasToken = process.env.REACT_APP_AZURE_SAS_TOKEN;

export const listVideos = async (sasToken) => {
  try {
    if (!accountName || !containerName || !sasToken) {
      throw new Error("Missing Azure configuration");
    }

    const blobServiceClient = new BlobServiceClient(
      `https://${accountName}.blob.core.windows.net${sasToken}`
    );

    const containerClient = blobServiceClient.getContainerClient(containerName);
    const videos = [];

    for await (const blob of containerClient.listBlobsFlat()) {
      // Include only video extensions
      if (/\.(mp4|mov|avi|mkv|webm)$/i.test(blob.name)) {
        videos.push({
          name: blob.name,
          url: `https://${accountName}.blob.core.windows.net/${containerName}/${blob.name}`,
          size: blob.properties.contentLength,
          type: blob.properties.contentType,
        });
      }
    }

    return videos;
  } catch (err) {
    console.error("Error fetching videos:", err);
    return [];
  }
};
